<template>
  <q-avatar :size="size"  v-ripple color="primary" text-color="white"
            class="q-mr-sm">
    <template v-if="project?.avatar">
      <q-img :src="avatarUrl" alt="avatar"/>
    </template>
    <template v-else>
      {{ project?.name[0].toUpperCase() }}
    </template>
  </q-avatar>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {Project} from "../models/project";
import {cdnUrl} from "../util/photoCdn";

const {project, size = "36px"} = defineProps<{
  project: Project,
  size?: string
}>()

const avatarUrl = computed(() => project?.avatar ? `${cdnUrl(project.avatar)}?quality=0.5` : "")

</script>

<style scoped>

</style>
